import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { GradeLabel, resolveGradeLabel } from '../lib/gradeLabel';
import { GradeOption } from '../types/finderConfig';

// Resolver for grade-option labels. See `resolveGradeLabel`.
export const useGradeLabel = (): ((option: GradeOption) => GradeLabel) => {
  const { t, i18n } = useTranslation();
  return useCallback((option: GradeOption) => resolveGradeLabel(option, t, i18n), [t, i18n]);
};
